// Arquivo: AuditPdfDocument.tsx
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { StockInventoryReportItem } from "../Types/StockInventory.types";
import { PdfLayout } from "./PdfLayout";

const styles = StyleSheet.create({
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { flexDirection: "row", backgroundColor: "#fff" },
  tableRowAlternate: { flexDirection: "row", backgroundColor: "#f2f2f2" },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#d3d3d3",
    padding: 5,
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
  },
  codeCol: { width: "20%" },
  nameCol: { width: "35%" },
  stockCol: { width: "15%", textAlign: "right" },
  countCol: { width: "15%", textAlign: "right" },
  diffCol: { width: "15%", textAlign: "right" },
  tableCellHeader: { fontSize: 10, fontFamily: "Helvetica-Bold" },
  tableCell: { fontSize: 9 },
});

type Props = { data: StockInventoryReportItem[] };

export function AuditPdfDocument({ data }: Props) {
  const reportDate = new Date().toLocaleDateString("pt-BR");

  return (
    <PdfLayout title={`Relatório de Auditoria - ${reportDate}`}>
      <View style={styles.table}>
        <View style={styles.tableRow} fixed>
          <View style={[styles.tableColHeader, styles.codeCol]}>
            <Text style={styles.tableCellHeader}>Código</Text>
          </View>
          <View style={[styles.tableColHeader, styles.nameCol]}>
            <Text style={styles.tableCellHeader}>Nome</Text>
          </View>
          <View style={[styles.tableColHeader, styles.stockCol]}>
            <Text style={styles.tableCellHeader}>Qtd. Estoque</Text>
          </View>
          <View style={[styles.tableColHeader, styles.countCol]}>
            <Text style={styles.tableCellHeader}>Qtd. Contada</Text>
          </View>
          <View style={[styles.tableColHeader, styles.diffCol]}>
            <Text style={styles.tableCellHeader}>Diferença</Text>
          </View>
        </View>
        {data.map((item, index) => (
          <View
            style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlternate}
            key={item.code + index}
            wrap={false}
          >
            <View style={[styles.tableCol, styles.codeCol]}>
              <Text style={styles.tableCell}>{item.code}</Text>
            </View>
            <View style={[styles.tableCol, styles.nameCol]}>
              <Text style={styles.tableCell}>{item.name}</Text>
            </View>
            <View style={[styles.tableCol, styles.stockCol]}>
              <Text style={styles.tableCell}>{item.quantityStock}</Text>
            </View>
            <View style={[styles.tableCol, styles.countCol]}>
              <Text style={styles.tableCell}>{item.quantity}</Text>
            </View>
            <View style={[styles.tableCol, styles.diffCol]}>
              <Text style={styles.tableCell}>{item.diference}</Text>
            </View>
          </View>
        ))}
      </View>
    </PdfLayout>
  );
}
